import React, { Component, ReactNode } from "react";
import { observer } from "mobx-react";
import NoData from "../noData";
import { Button, Tooltip } from "antd";
import "./index.less";
import EthSvg from '../connectWalletModal/ethSvg';
import { IPRsp } from "../../bean/ResponseBean";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { DerivativeWorkStatus, LicensedNFTStatus } from "../../constant/CommonConstant";
import { finneyToEth } from "../../utils/commonUtils";
import { getRoutePath, MythRouteId } from "../../router-config";
import MythImage from "../MythImage";

interface IProps extends RouteComponentProps {
    list: IPRsp[],
    title?: string,
    hideNoData?: boolean,
    className?: string,
    extra?: ReactNode,
    isOnePage?: boolean,
    saveStateData?:() => void,
}


interface IStates {
}


@observer
class NFTIPList extends Component<IProps, IStates> {

    renderBottom = (item: IPRsp) => {
        const price = !!item.price ? finneyToEth(item.price) : "— —";
        let button;
        if ((item.licensedNFT && item.status === LicensedNFTStatus.ISSUED)) {
            button = <Button className="myth-button">{item.LicensingPeriod}DAY Validity</Button>
            return <div className="item-bottom flex-row space-between"><span><EthSvg size={24} />{price}</span>{button}
            </div>
        } else if (!item.licensedNFT && item.status === DerivativeWorkStatus.ISSUED) {
            button = <Button className="myth-button"><i className="iconfont icon-fire"></i>PERMANENT</Button>
            return <div className="item-bottom flex-row space-between"><span><EthSvg size={24} />{price}</span>{button}
            </div>
        }
    };

    onClickCollectionItem = (item: IPRsp) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.IPListPage),
            state: { keywords: "", selectedCollectionId: item.collectionId }
        });
    };

    onClickIPItem = (item: IPRsp) => {
        const { isOnePage,saveStateData } = this.props;
        if(saveStateData){
            saveStateData();
        }
        if (isOnePage || !item.licensedNFT || item.status === LicensedNFTStatus.ISSUED) {
            //derivativeWork or ipl
            const url = getRoutePath(MythRouteId.MintIPInfo) + "?ipId=" + item.id + "&licensedNFT=" + item.licensedNFT;
            this.props.history.push(url);
        } else {
            //ip
            const url = getRoutePath(MythRouteId.OnePage) + "?ipId=" + item.id;
            this.props.history.push(url);
        }
    };

    render() {
        const { list, title, hideNoData, className, extra } = this.props;
        return <div className={className}>
            {title &&
                <div className="list-title-container flex-row space-between">
                    <span className="list-title">{title}</span>
                    {extra && extra}
                </div>}
            {list && list.length > 0 ? <div className="nftip-list flex-row">
                {list.map((item, i) => (
                    <div className="list-item" key={i} onClick={event => {
                        this.onClickIPItem(item)
                    }}>
                        <div className="img-container">
                            <img className="item-img" src={item.image} alt="" />
                            <Tooltip placement="bottom" color="rgba(255,255,255,0.8)" overlayClassName="tool-content"
                                title={`${item.collectionName} #${item.tokenId}`}>
                                <span className="ip-number"><i
                                    className="iconfont icon-copyright-circle-fil"></i>#{item.tokenId}</span>
                            </Tooltip>
                            <div className="collection-info" onClick={event => {
                                this.onClickCollectionItem(item);
                                event.stopPropagation();
                            }}>
                                <span><MythImage src={item.logo} alt="" />{item.collectionName}</span>
                            </div>
                        </div>
                        <div className="item-name">{item.name}</div>
                        {this.renderBottom(item)}
                    </div>
                ))}
            </div> : !!hideNoData ? <></> : <NoData />}
        </div>
    }
}

export default withRouter(NFTIPList);
